export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const SAVE_NOTIFICATION = 'SAVE_NOTIFICATION'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
